import { OrderSet } from '@exodus/models';
import eventReducers from './event-reducers.js';
import selectorDefinitions from './selectors/index.js';
const initialState = {
    error: null,
    isLoaded: false,
    data: OrderSet.EMPTY,
};
const ordersReduxDefinition = {
    id: 'orders',
    type: 'redux-module',
    initialState,
    eventReducers,
    selectorDefinitions,
};
export default ordersReduxDefinition;
